import React from 'react';
import { X } from 'lucide-react';

const ASSETS_URL = '';

const CertificateModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="relative max-w-2xl w-full">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 bg-white rounded-full p-1.5 shadow-lg hover:bg-gray-100 transition-colors"
          aria-label="Close"
        >
          <X size={20} className="text-gray-600" />
        </button>

        {/* Certificate image */}
        <img
          src={`${ASSETS_URL}/assets/images/certificate.png`}
          alt="Certificate of Completion"
          className="w-full rounded-xl shadow-2xl"
        />
      </div>
    </div>
  );
};

export default CertificateModal;
